import { useEffect } from "react";
import Breadcrumb from "../breacrumb/breadcrumb";
import icon1 from "../../../asset/image/new/hla-a13-01-01.svg";
import icon2 from "../../../asset/image/new/hla-a13-01-02.svg";
import icon3 from "../../../asset/image/new/hla-a13-01-03.svg";
import icon4 from "../../../asset/image/new/hla-a13-01-04.svg";
import TestingSteps from "../../../asset/image/new/hla-b-58-group.png";

function HLA5701() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ข้อมูลที่เกี่ยวข้อง", url: "/information" },
    { name: "เภสัชพันธุศาสตร์", url: "/information/pharmacogeneticTest" },
    { name: "HLA-B*13:01", url: "/information/pharmacogeneticTest/HLAB1301" },
  ];

  const Hla_57 = [
    {
      url: `${icon1}`,
      name: "HLA-B*13:01",
      title:
        "การตรวจ HLA-B*13:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Dapsone",
    },
    {
      url: `${icon2}`,
      name: "ความเสี่ยงต่อยา",
      title: "Dapsone (กลุ่มยาซัลโฟน) เป็นยาหลักที่ใช้ในการรักษาโรคเรื้อน (Leprosy) และรักษาโรคผิวหนังอักเสบชนิดตุ่มน้ำพอง (Dermatitis herpetiformis) รวมถึงใช้เพื่อป้องกันและรักษาโรคติดเชื้อฉวยโอกาสในผู้ป่วยที่มีภูมิคุ้มกันบกพร่อง",
    },
    {
      url: `${icon3}`,
      name: "อาการผื่นแพ้ยา",
      title:
        "เกิดกลุ่มอาการแพ้ยาแดปโซน (Dapsone Hypersensitivity Syndrome: DHS) ซึ่งประกอบด้วยอาการไข้ ผื่นผิวหนังอักเสบ และความผิดปกติของระบบเลือดและตับ",
    },
    {
      url: `${icon4}`,
      name: "อาการแพ้ยา",
      title: "มีไข้สูง ผื่นแดงอักเสบ ตัวเหลือง ตาเหลือง (จากภาวะตับอักเสบ) และอาจเกิดภาวะซีดจากการที่เม็ดเลือดแดงแตก ซึ่งเป็นอันตรายต่อระบบการทำงานของร่างกายหากไม่ได้รับการตรวจคัดกรองก่อนเริ่มยา",
    },
  ];
  return (
    <div className="global-page">
      <Breadcrumb pathItems={pathItems} />
      <div className="2lg:grid-cols-1 grid grid-flow-dense grid-cols-1 w-full gap-5 py-8 mt-6">
        {Hla_57.map((hla, index) => (
          <div
            key={index}
            className="sm:flex-col sm:items-center flex flex-row gap-4"
          >
            <div className="xl:max-h-36 overflow-hidden min-w-36 w-[15%] aspect-square p-5 justify-items-center align-middle bg-white rounded-lg border border-gray-400">
              <img
                className="object-scale-down h-full"
                src={hla.url}
                alt={`รูปประกอบ ${hla.name}`}
              />
            </div>
            <div className="flex flex-col gap-1 w-[80%] py-2">
              <span className="text-xl font-bold">{hla.name}</span>
              <span>{hla.title}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="text-xl font-bold py-4">
        ขั้นตอนการตรวจยีน HLA-B*13:01
      </div>
      <div className="sm:px-2 sm:py-0 w-full aspect-[5/2] px-10 py-5 rounded-xl border border-gray-400">
        <img
          className="object-contain w-full"
          src={TestingSteps}
          alt={`รูปขั้นตอนการตรวจยีน HLA-B*13:01`}
        />
      </div>
    </div>
  );
}
export default HLA5701;
